export { VALIDATOR_TYPE, autocompleteValidator } from "./autocompleteValidator.mjs";


//////////////////
// WEBPACK FOOTER
// ./~/handsontable/validators/autocompleteValidator/index.mjs
// module id = 372
// module chunks = 1